import { startAppListening } from '../..';
import { toggleOfferModal } from '../../reducers/common/modals/offerModal';
import { addOffer } from '../../reducers/common/thunks/offerThunks';

startAppListening({
    actionCreator: addOffer.fulfilled,
    effect: (_action, store) => {
        store.dispatch(toggleOfferModal());
    },
});
